import React from "react";
import Service from '../../service/Service';

export default function ShareOptions({ video, eleRef }) {
    return (
        <div className="sharing-options">
            <ul>
                <li className="facebook-share left" onClick={() => eleRef.shareVideo('facebook', video.url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => eleRef.shareVideo('twitter', video.url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => eleRef.shareVideo('pintrest', video.url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => eleRef.shareVideo('whatsapp', video.url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        </div>
    );
}